import styled from 'styled-components';

const MenuItem = styled.div`
  &:hover .submenu-items {
    display: block;
  }
`;

/**
 * A wraper for desktop submenu items so that we can scroll the items if it gets
 * too many.
 */
const SubmenuItemsWrap = styled.div`
  max-height: 80vh;
  overflow-y: auto;
`;

export { MenuItem, SubmenuItemsWrap }; // eslint-disable-line import/prefer-default-export
